module.exports = __webpack_public_path__ + "img/device-screen.ed17f008.svg";